import { CLASSROOM_ROUTES } from '@/shared/constants/routes';

/**
 * 로그인/회원가입 성공 후 명시적인 callbackUrl이 없을 때
 * 사용자 type에 따라 결정되는 기본 리다이렉트 경로를 반환한다.
 *
 * - 학생 → `/classrooms`
 * - 그 외 → `/public`
 *
 * 입력은 client `UserInfo.type` (소문자 union)이거나
 * raw API 응답의 `user.memberType` (대문자) 모두 허용한다.
 */
export const getDefaultAuthRedirectUrl = (
  userType: string | null | undefined,
): string => {
  return userType?.toLowerCase() === 'student'
    ? CLASSROOM_ROUTES.list()
    : '/public';
};
